import React from 'react'
import PropTypes from 'prop-types'

class Textarea extends React.Component {
  constructor(props) {
    super(props)
    this.textareaRef = React.createRef()
  }

  componentDidMount() {
    if (this.props.resize) window.setTimeout(this.resizeTextbox, 500)
  }

  onChange = elem => {
    const {onChangeHandle, resize} = this.props
    if (onChangeHandle) onChangeHandle(elem)
    if (resize) this.resizeTextbox()
  }

  resizeTextbox = () => {
    if (this.currentReferenceExists()) {
      this.textareaRef.current.style.height = `${this.textareaRef.current.scrollHeight}px`
    }
  }

  currentReferenceExists() {
    return this.textareaRef && this.textareaRef.current
  }

  render() {
    const {rows, maxLength, value, defaultValue, labelText, placeholder, isDisabled, onBlurHandle, modifier, testid} =
      this.props

    return (
      <div className="textarea">
        <label htmlFor="textarea">
          {labelText}
          <textarea
            data-testid={testid}
            id="textarea"
            className={modifier && modifier}
            rows={rows}
            maxLength={maxLength}
            value={value}
            defaultValue={defaultValue}
            disabled={isDisabled}
            placeholder={placeholder || 'Bitte geben Sie etwas ein...'}
            onChange={elem => this.onChange(elem)}
            onBlur={onBlurHandle ? elem => onBlurHandle(elem) : undefined}
            ref={this.textareaRef}
          />
        </label>
      </div>
    )
  }
}

Textarea.propTypes = {
  testid: PropTypes.string,
  rows: PropTypes.number,
  maxLength: PropTypes.number,
  isDisabled: PropTypes.bool,
  onChangeHandle: PropTypes.func,
  onBlurHandle: PropTypes.func,
  labelText: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  resize: PropTypes.bool,
  modifier: PropTypes.string,
}

export default Textarea
